export const getCookie = (key: string) => {
  const allCookies = document.cookie.split('; ');
  const mpCookie = allCookies.find((cookie) => cookie.includes(key))?.split('=');
  const cookieData = mpCookie?.[1];

  if (cookieData) {
    try {
      return JSON.parse(decodeURIComponent(cookieData)) as any;
    } catch (error) {
      console.error(error);
    }
  }

  return null;
};

export const setCookie = (token: string, data: Record<string, any>, maxAge?: number) => {
  const age = maxAge ? `max-age=${maxAge};` : '';
  document.cookie = `${token}=${encodeURIComponent(JSON.stringify(data))};${age}path=/`;
};
